/**
 * Styled Components - Created by eduardoquintero on 17/11/20.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import { BLACK, GRAY, WHITE } from '../../../theme/colors'

interface ButtonProps {
  disabled?: boolean
  show?: boolean
}

export const MenuContainer = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  padding: 10px 100px;
  position: absolute;
  font-family: Avenir;
  pointer-events: none;
  @media (max-width: 768px) {
    padding: 10px;
  }
`

interface ButtonWrapperProps {
  unable: boolean
}

export const ButtonWrapper = styled.div`
  pointer-events: all;
  visibility: ${({ show }: ButtonProps) => show ? 'visible' : 'hidden'};
  margin-top: 25px;
  text-align: right;
  align-self: right;
  .ant-btn-primary {
    text-shadow: none;
    box-shadow: none;
    background-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : WHITE};
    color: BLACK;
    border-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : BLACK};
  }
  .ant-btn-primary:hover {
    background-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : WHITE};
    color: BLACK;
    border-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : BLACK};
  }
`

export const GrayButtonWrapper = styled.div`
  pointer-events: all;
  visibility: ${({ show }: ButtonProps) => show ? 'visible' : 'hidden'};
  margin-top: 25px;
  text-align: right;
  align-self: right;
  .ant-btn-primary {
    text-shadow: none;
    box-shadow: none;
    background-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : WHITE};
    color: BLACK;
    border-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : BLACK};
  }
  .ant-btn-primary:hover {
    background-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : WHITE};
    color: BLACK;
    border-color: ${({ unable }: ButtonWrapperProps) =>
      unable ? GRAY : BLACK};
  }
`

export const StyledButton = styled(Button)`
  height: 40px;
  border-radius: 25px;
  box-shadow: 0px 2px 4px 0px #c6c6c6 !important;
  padding-inline: 30px;
  font-weight: 500;
  &.continue-button {
    color: #FFFFFF;
    border: 1.5px solid #302628;
    background: #302628;
    padding-inline: 48px;
  }
`

export const UnstyledButton = styled.button`
  background: unset;
  border: unset;
  cursor: pointer;
  margin-right: 6px;
  color:  #2196F3;
  text-align: center;
  font-family: "Avenir Next";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: underline;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/Menu/styledComponents.tsx